/**
 * Created by pmnia on 7/1/15.
 */
require('./widgets.module.js');
require('./angular-modal-Service.js');
require('./ui-bootstrap.directives.fix.js');
require('./obt-ProfileCard.directive.js');
require('./obt-Match.directive.js');
require('./obt-errorImage.directive.js');
require('./obt-Calendar.service.js');
require('./obt-Calendar.directive.js');
require('./obt-affix-target.directive.js');
require('./ht-widget-header.directive.js');
require('./ht-img-person.directive.js');
require('./map/obt-map.directive.js');
require('./hreflang.directive.js');
require('./obt-moment.filters.js');
require('./filter-form.directive.js');
require('./customDatepicker/custom-datepicker.js');
require('./obtSection/obtSection.directive.js');
require('./obt-select-cascade.js');
require('./obt-online-receptionist.directive.js');
require('./obt-menu.directive.js');
require('./obt-booking-button.directive.js');
require('./ui-tinymce.directive.js');
require('./section2formItem/section2FormItem.directive.js');
require('./viewGalleryDirective/viewGaller.directive.js');
require('./owl.carousel.directive.js');
require('./viewGalleryDirective/viewServiceDirective.js');
require('./uploadImageChange.js');
require('./uploadService.js');
require("./ui-carousel/ui.carousel.js");
require("./ui-carousel/ui.carousel.css");



/*****************
 ** WEBPACK FOOTER
 ** ./app/widgets/widget.require.js
 ** module id = 172
 ** module chunks = 0
 **/